
















import Vue from 'vue'
import SearchToolbar from '@/components/Reports/SearchToolbar.vue'
// Queries
import { mkAllQuery, mkSummaryQuery } from './queries'
// Types
import { PeriodData, Range } from './types'
// fp-ts
import { pipe, flow } from 'fp-ts/lib/function'
import { tryCatch, fold, fromPredicate as fromPredicateE, chain } from 'fp-ts/TaskEither'
import { Task } from 'fp-ts/Task'

const rangeDefault: Range = {
  from: '',
  till: ''
}

export default Vue.extend({
  name: 'RequestOverview',
  components: { SearchToolbar },
  props: {
    user: Object,
    action: String
  },
  data: () => ({
    query: '',
    range: rangeDefault,
    target: null,
    showError: false
  }),
  computed: {
    canRequest (): boolean {
      return this.target !== null &&
      this.range?.from !== '' &&
      this.range?.to !== ''
    }
  },
  methods: {
    reset (): void {
      this.range = rangeDefault
      this.target = null
    },
    async sendRequest (): Promise<void> {
      const url = 'https://hooks.slack.com/services/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'
      const options = {
        method: 'POST',
        headers: {
          'Accept': 'application/json'
        },
        body: JSON.stringify({ text: this.query })
      }

      pipe(
        tryCatch(
          () => fetch(url, options),
          e => new Error(String(e))
        ),
        chain(flow(
          fromPredicateE(
            (r: Response) => r.status === 200,
            () => new Error(String('Invalid response status'))
          )
        )),
        fold(
          (e: Error) => this.$swal('Error', this.t({ s: 'periodic.requestFail', component: 'Reports' }), 'error'),
          (r: Response): Task<void> => {
            this.$swal('Done', this.t({ s: 'periodic.requestDone', component: 'Reports' }), 'success')
            return this.reset()
          }
        )
      )()
    },
    getTrips ({ range, target }: PeriodData): void {
      this.range = range
      this.target = target

      if (!range?.till || !range?.from || !target) return

      const queryFn = this.action === 'summary' ? mkSummaryQuery : mkAllQuery
      const query = queryFn(this.user, `${target.id}`, range)

      this.query = `Incoming report request
        Email:    ${this.user.email}
        Vendor:   ${this.user.sub_vendor.name}
        VendorID  ${this.user.sub_vendor.id}
        Type      ${this.action}
        Query:    ${query}
      `
    }
  },
  watch: {
    target (t) {
      if ((t?.amount || 0) > 100) this.showError = true
    }
  }
})
